/**
 * By Florist Jin — Native Web Components for Dawn (OS 2.0)
 * Handles Delivery/Pick-up Date validation and async Cart Attribute syncing
 */
if (!customElements.get('florist-delivery-date')) {
  class FloristDeliveryDate extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="date"]');
      if (!this.input) return;

      this.setDateBounds();
      this.handleChange = this.onDateChange.bind(this);
      this.input.addEventListener('change', this.handleChange);

      this.bindCheckoutValidation();
    }

    disconnectedCallback() {
      if (this.input && this.handleChange) {
        this.input.removeEventListener('change', this.handleChange);
      }
    }

     formatDateLocal(dateObj) {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    setDateBounds() {
      const today = new Date();
      const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, today.getDate());
      const minStr = this.formatDateLocal(today);
      const maxStr = this.formatDateLocal(maxDate);

      this.input.setAttribute('min', minStr);
      this.input.setAttribute('max', maxStr);
    }

    onDateChange(event) {
      const selectedDate = event.target.value;
      // Sync any other delivery date inputs on the page (e.g., drawer + cart page)
      document.querySelectorAll('florist-delivery-date input[type="date"]').forEach((el) => {
        if (el !== this.input) {
          el.value = selectedDate;
        }
      });

      const updateUrl = `${window.routes?.cart_update_url || '/cart/update'}.js`;
      fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'Delivery Date': selectedDate,
          },
        }),
      }).catch((err) => {
        console.error('Failed to update Delivery Date attribute:', err);
      });
    }

    bindCheckoutValidation() {
      const formId = this.input.getAttribute('form');
      const container = this.closest('.drawer__footer, .cart__footer') || document;
      const checkoutButtons = container.querySelectorAll('button[name="checkout"]');

      checkoutButtons.forEach((btn) => {
        if (btn.dataset.floristBound === 'true') return;
        btn.dataset.floristBound = 'true';
        btn.addEventListener('click', (evt) => {
          const activeInput = container.querySelector('florist-delivery-date input[type="date"]') || this.input;
          if (activeInput && !activeInput.checkValidity()) {
            evt.preventDefault();
            evt.stopPropagation();
            activeInput.reportValidity();
          }
        });
      });

      if (formId) {
        const formEl = document.getElementById(formId);
        if (formEl && formEl.dataset.floristBound !== 'true') {
          formEl.dataset.floristBound = 'true';
          formEl.addEventListener('submit', (evt) => {
            const activeInput = document.querySelector(`florist-delivery-date input[form="${formId}"]`) || this.input;
            if (activeInput && !activeInput.checkValidity()) {
              evt.preventDefault();
              activeInput.reportValidity();
            }
          });
        }
      }
    }
  }

  customElements.define('florist-delivery-date', FloristDeliveryDate);
}
